import styled from 'styled-components';

export const Container = styled.div`

    margin-bottom: 20px;

`;

export const HeaderContainer = styled.div`

    height: 80px;
    // background-color: #fec604;
    background-color: ${props => props.color};
    margin: 10px 60px 0px 60px;
    
    display: flex;
    justify-content: space-between;
    padding: 0 20px 0 20px;
    align-items: center;
    text-align: center;
    border-radius: 10px;
    box-shadow: 5px 5px 10px 1px #000;
`;

export const Title = styled.h1``;

export const IconButton = styled.button`
    background-color: #FDFD96;
    border-radius: 5px;
    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #F0E68C;
    }
`;

export const DealDetailSpec = styled.div`

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    gap: 16px;

    margin-right: 120px;
    margin-left: 120px;
    margin-bottom: 40px;

    padding-left: 10px;
    padding-right: 10px;

    background-color: #193553;

    box-shadow: 5px 5px 10px 1px #000;

    border-radius: 0 0 10px 10px;

`;

export const DealDetailTextBox = styled.div`

    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;

    line-break: anywhere;

    /* background-color: #535ba8; */
    background-color: #d3d3d3;
    flex-grow: 1;
    flex: 1;
    text-align: left;
    
    margin-top: 10px;
    margin-bottom: 10px;

    padding: 5px 20px 5px 20px;

    border-radius: 10px;

`;

export const ButtonsBox= styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    > button {
        padding: 5px;
        gap: 5px;
        margin-right: 5px;
        border-radius: 5px;
        transition: opacity .3s;
        &:hover {
            opacity: .7;
            background-color: #F0E68C;
        }
    }
`;